import i18n from '../../../../../i18n.jsx';

const TYPES = {
  INDIVIDUAL_PLAN: 'individual_plan',
  STUDENT_EVALUATION_GRADES: 'student_evaluation_grades',
  DISSERTATION_EXAM_APPLICATION: 'dissertation_exam_application',
  SUBJECTS_EXAM_APPLICATION: 'subjects_exam_application',
  DISSERTATION_DEFENSE_APPLICATION: 'dissertation_defense_application',
  DISSERTATION_EXAM_EXAMINER_PROPOSAL: 'dissertation_exam_examiner_proposal',
  DISSERTATION_DEFENSE_EXAMINER_PROPOSAL:
    'dissertation_defense_examiner_proposal',
};

const matchesSchoolYear = (record, schoolYearId) => {
  if (!record) {
    return false;
  }

  if (!schoolYearId) {
    return true;
  }

  return Number(record.phd_school_year_id) === Number(schoolYearId);
};

const pickLatest = (records) =>
  [...(records || [])].sort(
    (a, b) =>
      new Date(b?.updated_at || b?.created_at || 0).valueOf() -
      new Date(a?.updated_at || a?.created_at || 0).valueOf(),
  )[0];

const pickForSchoolYear = (records, schoolYearId) => {
  const matching = (records || []).filter((record) =>
    matchesSchoolYear(record, schoolYearId),
  );
  return pickLatest(matching.length > 0 ? matching : records);
};

const planHasSubjects = (plan) =>
  Array.isArray(plan?.subjects) && plan.subjects.length > 0;

export const getPhdDocumentDependencyState = ({
  documentType,
  student,
  schoolYearId,
}) => {
  if (!student) {
    return {
      missingItems: [],
      message: null,
    };
  }

  const plan = pickForSchoolYear(student.individual_plans, schoolYearId);
  const thesis = pickForSchoolYear(student.theses, schoolYearId);
  const dissertationExamApplication = pickForSchoolYear(
    student.dissertation_exam_applications,
    schoolYearId,
  );
  const dissertationDefenseApplication = pickForSchoolYear(
    student.dissertation_defense_applications,
    schoolYearId,
  );

  const missingItems = [];

  switch (documentType) {
    case TYPES.INDIVIDUAL_PLAN:
      if (!thesis) {
        missingItems.push(i18n.t('priradená dizertačná téma'));
      }
      break;
    case TYPES.STUDENT_EVALUATION_GRADES:
      if (!plan) {
        missingItems.push(i18n.t('individuálny plán pre zvolený školský rok'));
        break;
      }
      if (!planHasSubjects(plan)) {
        missingItems.push(i18n.t('povinné predmety v individuálnom pláne'));
      }
      break;
    case TYPES.DISSERTATION_EXAM_APPLICATION:
    case TYPES.SUBJECTS_EXAM_APPLICATION:
      if (!plan) {
        missingItems.push(i18n.t('individuálny plán pre zvolený školský rok'));
        break;
      }
      if (!planHasSubjects(plan)) {
        missingItems.push(i18n.t('povinné predmety v individuálnom pláne'));
      }
      break;
    case TYPES.DISSERTATION_DEFENSE_APPLICATION:
      if (!plan) {
        missingItems.push(i18n.t('individuálny plán pre zvolený školský rok'));
      }
      if (!dissertationExamApplication) {
        missingItems.push(i18n.t('prihláška na dizertačnú skúšku'));
      }
      break;
    case TYPES.DISSERTATION_EXAM_EXAMINER_PROPOSAL:
      if (!dissertationExamApplication) {
        missingItems.push(i18n.t('prihláška na dizertačnú skúšku'));
      }
      break;
    case TYPES.DISSERTATION_DEFENSE_EXAMINER_PROPOSAL:
      if (!dissertationDefenseApplication) {
        missingItems.push(i18n.t('prihláška na obhajobu dizertačnej práce'));
      }
      break;
  }

  return {
    missingItems,
    message:
      missingItems.length > 0
        ? i18n.t(
            'Dokument nie je možné vytvoriť, pretože neexistuje: {{items}}.',
            { items: missingItems.join(', ') },
          )
        : null,
  };
};

export const PHD_DOCUMENT_DEPENDENCY_TYPES = TYPES;
